import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostDokumentHinterlegenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostDokumentHinterlegenCommandService],
  exports: []
})
export class PostDokumentHinterlegenCommandServiceModule { }
